export { default } from './SuggestedSearches'
